module.exports = __webpack_public_path__ + "3b2af543c3e93d40c4b246ee16bd0eff.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/rollerskates-yellow-s.png
// module id = 2419
// module chunks = 0